import type { IconSvgObject } from './types';

const DirectionLeft02Icon: IconSvgObject = [
  ["path", { d: "M13 11V21M13 3V4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 21H16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.20088 4.41876C8.3886 4.15597 8.69167 4 9.01462 4H17C17.5523 4 18 4.44772 18 5V10C18 10.5523 17.5523 11 17 11H9.01462C8.69167 11 8.3886 10.844 8.20088 10.5812L6 7.5L8.20088 4.41876Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DirectionLeft02Icon;
